import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import s from './CricketScorecardV2.scss';

const getBallDetails = (runs, wicket, description) => {
  let data = '';

  if (wicket === 'Yes') {
    data = parseInt(runs, 10) > 0 ? `${runs}W` : 'W';
  } else if (description.indexOf('NB') > -1) {
    data = `${description.substr(0, description.indexOf('NB'))}nb`;
  } else if (description.indexOf('WD') > -1) {
    data = `${description.substr(0, description.indexOf('WD'))}wd`;
  } else if (description.indexOf('LB') > -1) {
    data = `${description.substr(0, description.indexOf('LB'))}lb`;
  } else {
    data = runs;
  }

  return data;
};

const createOverUI = over => (
  <li className={s.tableItem} key={over.number}>
    <p className={s.text}>
      {over.number} ov - {over.bowler}
    </p>
    {over.balls.map &&
      over.balls.map(ball => {
        const ballClass = classNames({
          [`${s.score}`]: true,
          [`${s.wicket}`]: ball.wicket === 'Yes',
          [`${s.wide}`]: ball.details.indexOf('WD') > -1,
          [`${s.noball}`]: ball.details.indexOf('NB') > -1,
          [`${s.legbye}`]: ball.details.indexOf('LB') > -1,
          [`${s.six}`]:
            parseInt(ball.runs, 10) === 6 ||
            parseInt(ball.details[0], 10) === 6,
          [`${s.four}`]:
            parseInt(ball.runs, 10) === 4 ||
            parseInt(ball.details[0], 10) === 4,
        });
        return (
          <span className={ballClass} key={`${ball.over}-${ball.number}`}>
            {getBallDetails(ball.runs, ball.wicket, ball.details)}
          </span>
        );
      })}
  </li>
);

class Overs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverPopup: false,
    };
  }
  toggleOverPopup = () => {
    this.setState({ showOverPopup: !this.state.showOverPopup }, () => {
      if (this.state.showOverPopup) {
        gaWrapper(
          'send',
          'event',
          'SportsLiveblog_New',
          'click',
          'fullScorecard_tab_allovers',
        );
      }
    });
    document.body.classList.toggle('disable-scroll');
  };
  static propTypes = {
    overs: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    equation: PropTypes.shape({}).isRequired,
  };
  render() {
    const { overs, equation } = this.props;

    return (
      overs &&
      overs.length > 0 && (
        <div className={`${s.scorecardTable} ${s.overDetails}`}>
          <div className={s.tableHeading}>
            <div className={s.col}>
              <strong>BOWLING - Last 5 Overs </strong>
            </div>
            <div className={s.col}>{equation.overs} OVERS</div>
          </div>
          <ul>
            {overs.map &&
              overs.map((over, index) => index < 5 && createOverUI(over))}
          </ul>
          {overs &&
            overs.length > 5 && (
              <div className={`${s.tableItem} ${s.moreBtnWrapper} `}>
                <span className={s.moreBtn} onClick={this.toggleOverPopup}>
                  VIEW more OVERS
                </span>
              </div>
            )}

          {/* Popup div  */}
          {this.state.showOverPopup && (
            <div className={s.oversPopup}>
              <div className={s.inner}>
                <div className={s.tableHeading}>
                  <div className={s.col}>
                    <strong>BOWLING - {equation.overs} </strong>
                    Overs
                  </div>
                </div>
                {/* Close button */}
                <span className={s.closeBtn} onClick={this.toggleOverPopup} />
                <ul className={s.scoreWrapper}>
                  {overs.map && overs.map(over => createOverUI(over))}
                </ul>
              </div>
            </div>
          )}
        </div>
      )
    );
  }
}

export default Overs;
